import React from 'react'
import { InformationCircleIcon } from '@heroicons/react/20/solid'
import { Box, Tooltip } from '@chakra-ui/react'

type Props = {
  label: string
}

const InfoHint = ({ label }: Props) => {
  return (
    <Tooltip hasArrow label={label} placement='top-start' maxW='340px' openDelay={200}>
      <Box
        as='span'
        aria-label='More information'
        display='inline-flex'
        alignItems='center'
        color='gray.500'
        cursor='help'
        verticalAlign='middle'
        ml={1}
      >
        <InformationCircleIcon className='h-4 w-4' />
      </Box>
    </Tooltip>
  )
}

export default InfoHint
